import { CustomerOrderOfferView } from "src/api/generated/erp/db/types/tables/customerOrderOfferView.ts";

export type CustomerOfferOrderChangesMode = "readOnly" | "editable";

/**
 * Order changes are shown on an accepted offer, where line reconfigurations create them, and read-only after an order
 * is created from the offer. Returns undefined when order changes are not shown.
 */
export function getCustomerOfferOrderChangesMode(
	offer: Pick<CustomerOrderOfferView, "customerOrderId" | "customerOrderOfferState">,
): CustomerOfferOrderChangesMode | undefined {
	if (offer.customerOrderId != null) return "readOnly";
	if (offer.customerOrderOfferState === "ACCEPTED") return "editable";
	return undefined;
}

/**
 * Converts plain text, such as an AI-generated description, to HTML content of an order change.
 */
export function plainTextToOrderChangeContent(text: string): string {
	return text.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll("\n", "<br/>");
}
